import React from "react";
import { useState } from "react";
import { useHistory } from "react-router-dom";
import { isMobile } from "react-device-detect";

import Musicas from "./Musicas";
import Videos from "./Videos";
import Pronuncias from "./Pronuncias";

import {
  AppBar,
  Avatar,
  Grid,
  ListItem,
  ListItemButton,
  ListItemText,
  styled,
  Toolbar,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

export default function Unidade(props) {
  const history = useHistory();
  const [tipoLista, setTipoLista] = useState(1);
  const dados = props.location.state.dadosUnidade;

  return (
    <>
      <AppBar position="fixed">
        <Toolbar style={{ background: "#E51D3D", color: "white" }}>
          <ArrowBackIcon
            onClick={() => history.push("lista")}
            style={{
              marginRight: 20,
              cursor: "pointer",
            }}
          />
          <h2 style={{ fontFamily: "Gilroy-ExtraBold" }}>
            Conteúdo da unidade
          </h2>
        </Toolbar>
      </AppBar>

      <Main
        style={{
          background: "white",
          fontFamily: "Gilroy-ExtraBold",
        }}
      >
        <Toolbar />
        <br />
        <div style={{ background: "#a3a3a3" }}>
          <h2 style={{ fontWeight: "bold", color: "white", marginLeft: 10 }}>
            {dados.cicloNome} {dados.unidadeNumero} - {dados.unidadeTitulo}
          </h2>
        </div>

        <br />

        <div style={{ padding: isMobile ? 10 : "0px 50px 0 50px" }}>
          <Grid
            style={{
              background: "#3D79AD",
              padding: 10,
              borderRadius: 15,
            }}
            container
          >
            <Grid item xs={12}>
              <ListItem
                sx={{
                  width: "100%",
                  paddingBottom: "20px",
                }}
              >
                <Avatar>IMG</Avatar>
                <ListItemText
                  primary={
                    <h3
                      style={{
                        fontFamily: "Gilroy-ExtraBold",
                        paddingLeft: 10,
                        color: "white",
                      }}
                    >
                      {dados.unidadeNumero} - {dados.unidadeTitulo}
                    </h3>
                  }
                />
              </ListItem>
            </Grid>

            <Grid
              item
              xs={12}
              style={{
                background: "white",
                paddingTop: 10,
                borderRadius: 15,
              }}
              container
            >
              <Grid item xs={4} style={{ paddingLeft: 10 }}>
                <ListItemButton
                  style={{
                    textAlign: "center",
                    // background: tipoLista === 1 && "#e8e8e8",
                    borderTopLeftRadius: 15,
                    borderTopRightRadius: 15,
                    borderRight: "2px solid rgb(213, 213, 213)",
                    borderTop: "2px solid rgb(213, 213, 213)",
                    borderLeft: "2px solid rgb(213, 213, 213)",
                    borderBottom:
                      tipoLista !== 1 && "2px solid rgb(213, 213, 213)",
                  }}
                  onClick={() => setTipoLista(1)}
                >
                  <ListItemText
                    primary={
                      isMobile ? (
                        <h4
                          style={{
                            fontFamily: "Gilroy-ExtraBold",
                            color: "#A3A3A3",
                          }}
                        >
                          Videos
                        </h4>
                      ) : (
                        <h3
                          style={{
                            fontFamily: "Gilroy-ExtraBold",
                            color: "#A3A3A3",
                          }}
                        >
                          Videos
                        </h3>
                      )
                    }
                  />
                </ListItemButton>
              </Grid>
              <Grid item xs={4}>
                <ListItemButton
                  style={{
                    textAlign: "center",
                    borderTopLeftRadius: 15,
                    borderTopRightRadius: 15,
                    borderBottom:
                      tipoLista !== 2 && "2px solid rgb(213, 213, 213)",
                    borderTop: "2px solid rgb(213, 213, 213)",
                  }}
                  onClick={() => setTipoLista(2)}
                >
                  <ListItemText
                    primary={
                      isMobile ? (
                        <h4
                          style={{
                            fontFamily: "Gilroy-ExtraBold",
                            color: "#A3A3A3",
                          }}
                        >
                          Músicas
                        </h4>
                      ) : (
                        <h3
                          style={{
                            fontFamily: "Gilroy-ExtraBold",
                            color: "#A3A3A3",
                          }}
                        >
                          Músicas
                        </h3>
                      )
                    }
                  />
                </ListItemButton>
              </Grid>
              <Grid item xs={4} style={{ paddingRight: 10 }}>
                <ListItemButton
                  style={{
                    textAlign: "center",
                    borderTopLeftRadius: 15,
                    borderTopRightRadius: 15,
                    borderBottom:
                      tipoLista !== 3 && "2px solid rgb(213, 213, 213)",
                    borderRight: "2px solid rgb(213, 213, 213)",
                    borderTop: "2px solid rgb(213, 213, 213)",
                    borderLeft: "2px solid rgb(213, 213, 213)",
                  }}
                  onClick={() => setTipoLista(3)}
                >
                  <ListItemText
                    primary={
                      isMobile ? (
                        <h4
                          style={{
                            fontFamily: "Gilroy-ExtraBold",
                            color: "#A3A3A3",
                          }}
                        >
                          Pronúncias
                        </h4>
                      ) : (
                        <h3
                          style={{
                            fontFamily: "Gilroy-ExtraBold",
                            color: "#A3A3A3",
                          }}
                        >
                          Pronúncias
                        </h3>
                      )
                    }
                  />
                </ListItemButton>
              </Grid>

              <Grid
                item
                xs={12}
                style={{
                  borderBottomRightRadius: 15,
                  padding: "0px 10px 10px 10px",
                }}
              >
                {tipoLista === 1 && <Videos unidadeId={dados.unidadeId} />}
                {tipoLista === 2 && <Musicas unidadeId={dados.unidadeId} />}
                {tipoLista === 3 && <Pronuncias dados={dados} />}
              </Grid>
            </Grid>
          </Grid>
        </div>
      </Main>
    </>
  );
}

const Main = styled("main", { shouldForwardProp: (prop) => prop !== "open" })(
  ({ theme, open }) => ({
    flexGrow: 1,
    // padding: theme.spacing(1),
    transition: theme.transitions.create("margin", {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    ...(open && {
      transition: theme.transitions.create("margin", {
        easing: theme.transitions.easing.easeOut,
        duration: theme.transitions.duration.enteringScreen,
      }),
      marginLeft: 250,
    }),
  })
);
